import styled from 'styled-components';
import { mixins } from '../../../../css';

export const SubMenu = styled.div`
  display: block;
  position: absolute;
  top: ${mixins.pxToRem(80)};
  right: 0;
  width: 30vw;
  max-height: calc(100vh - ${mixins.pxToRem(120)});
  min-height: ${mixins.pxToRem(80)};
  overflow-x: hidden;
  overflow-y: auto;
  max-width: ${mixins.pxToRem(300)};
  border: 1px solid;
  ${({ theme }) => `border-color: ${theme.darkerTheme}`};
  border-top: none;
  transition: top 200ms ease-in;
  ${({ theme }) => `background-color: ${theme.darkTheme}`};
  a {
    padding: ${mixins.pxToRem(15)} ${mixins.pxToRem(20)};
    ${({ theme }) => `color: ${theme.lightText}`};

    &:hover {
      ${({ theme }) => `background-color: ${theme.mainTheme}`};
      ${({ theme }) => `color: ${theme.lightTheme}`};
    }
  }
`;

export const JoinOrg = styled.div``;

export const SignOutLink = styled.div`
  ${({ theme }) => `background-color: ${theme.darkerTheme}`};
`;
